import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueGtag from "vue-gtag";

createApp(App).use(VueGtag, {
  config: { id: "G-4SGJ3D5RCB" }
}).mount("#app");


